module.exports = "/fonts/vendor/socicon/socicon.svg?a35b65744f557fab5424e99bb6d4e980";